import Vue from "vue";
import axios from "axios";
import { Toast } from "vant";
import { getUrlQueryValueByKey, isiOS, isMiniProgram, isAndroid} from "./util";
import { signIn } from './InteractionWithJs';

Vue.prototype.axios = axios;
// Vue.use(axios); // Vue.axios/this.axios/this.$http使用axios，一次封装方便协作规范

var loadingNum = 0;
var loadingInstance;
let noCheak = true
// 添加请求拦截器
axios.interceptors.request.use(
    (config) => {
        if (config.url.indexOf('getAllShopsByBrand') < 0 &&
            config.url.indexOf('getLocalDateTime') < 0 &&
            config.url.indexOf('getDrawCache') < 0 &&
            config.url.indexOf('getBookingCarData') <0 &&
            config.url.indexOf('hxBookingCarData') < 0 &&
            config.url.indexOf('getDrawStatus') < 0 &&
            config.url.indexOf('updateDrawState') < 0 &&
            config.url.indexOf('getDrawCount') < 0 && 
            config.url.indexOf('checkDrawCache') < 0 && 
            config.url.indexOf('queryDrawRecordList') < 0 && 
            config.url.indexOf('getDrawWinList') < 0 && 
            config.url.indexOf('dzDoDraw') < 0 && 
            config.url.indexOf('updateBookingCarData') < 0 &&
            config.url.indexOf('getDrawInfoList') < 0 &&
            config.url.indexOf('getBookingCarState') < 0 &&
            config.url.indexOf('getDrawActId') < 0 &&
            config.url.indexOf('isSubUser') < 0 &&
            config.url.indexOf('getGoodsStatus') < 0 &&
            config.url.indexOf('updateDrawStatus') < 0 &&
            config.url.indexOf('doNewDraw') < 0 &&
            config.url.indexOf('addLog') < 0 &&
            config.url.indexOf('getStaffByName') < 0

        ) {
            loadingNum++;
            Toast.loading({
                message: '加载中...',
                forbidClick: true,
                duration: 0
            });
        }
        const token = getUrlQueryValueByKey(location.href, 'token');
        if (token && token.search('guest') !== 0) { // guest开头的token为游客，游客不需要传token
            config.headers['X-Litemall-Token'] = token;
        };
        if (!isMiniProgram() && config.url.indexOf('getKfOrderInfo') < 0 && config.url.indexOf('prepay/v1/mini/1') < 0) {
            if (isiOS()) {
                config.headers['Client-OS'] = 'IOS';
            } else if(isAndroid()) {
                config.headers['Client-OS'] = 'Android';
            }
        };
        return config;
    },
    (error) => {
        // 对请求错误做些什么
        return Promise.reject(error);
    }
);

// 添加响应拦截器
axios.interceptors.response.use(
    (response) => {
        console.log(response, 'response');
        // 对响应数据做点什么
        // store.commit("reduce", 1);
        if (response.request.responseURL.indexOf('getAllShopsByBrand') < 0 && response.request.responseURL.indexOf('getLocalDateTime') < 0 && response.request.responseURL.indexOf('getDrawCache') < 0 && response.request.responseURL.indexOf('addLog') < 0 && response.request.responseURL.indexOf('getStaffByName') < 0) {
            loadingNum--;
        }
        if (loadingNum == 0) {
            Toast.clear();
        }
        if (response.data.code == 500) {
            return response
        } else if (response.data.errno == 501) {
            if (response.request.responseURL.indexOf('fastadd') != -1) {
                if (isMiniProgram()) {
                    Toast("请登录");
                    setTimeout(() => {
                        wx.miniProgram.switchTab({
                            url: "/pages/ucenter/index/index",
                        });
                    }, 1500);
                } else {
                    signIn();
                }
            }
            // Toast('登录超时')
            signIn();
        } else {
            return response;
        }
    },
    (error) => {
        // 对响应错误做点什么
        return Promise.reject(error);
    }
);

export default {
    // post请求
    post(url, params) {
        return new Promise((resolve, reject) => {
            axios({
                method: "post",
                url: url,
                headers: {
                    "Content-Type": "application/json;charset=UTF-8;",
                },
                data: params,
            })
                .then((res) => {
                    if (res.status === 200) {
                        resolve(res);
                    }
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },
    get(url, params) {
        return new Promise((resolve, reject) => {
            axios(url, {
                params,

                headers: {
                    // "Access-Control-Allow-Origin":"*",
                }
            })
                .then((res) => {
                    if (res.status === 200) {
                        resolve(res);
                    }
                },)
                .catch((error) => {
                    reject(error);
                });
        });
    }
};